import { Routes, Route, Navigate } from "react-router-dom";
import { routes } from "./routes";
import Aplicacion from "../pages/aplicationPage";
import ApplicationsDetailsPage from "../pages/applicationsDetailsPage";
import UsersPage from "../pages/usersPage";
import CreateUserPage from "../pages/userCreatePage";
import CreateAssignmentPage from "../pages/assignmentCreatePage";
import Root from "../pages/root";
import PhaseQuestionnairesPage from "../pages/phaseQuestionnairesPage";
import UserDetailsPage from "../pages/userDetailsPage";
import QuestionnairesPage from "../pages/questionnairesPage";
import AspectsPage from "../pages/aspectsPage";
import AnswerTypesOptionsPage from "../pages/answerTypesOptionsPage";
import QuestionnaireCreatePage from "../pages/questionnaireCreatePage";
import ApplicationAssignmentsPage from "../pages/applicationAssignmentsPage";
import ReportsPage from "../pages/reportsPage";
import UsersLogin from "../pages/usersLogin";
import QuestionnairePreview from "../pages/questionnairePreviewPage";
import QuestionsPage from "../pages/questionsPage";
import InstrumentsPage from "../pages/instrumentsPage";
import NotFoundPage from "../pages/notFoundPage";
import DocViewerPage from "../pages/DocViewerPage";
import HomePage from "../pages/homePage";
import ForbiddenPage from "../pages/forbiddenPage";
import { useUserStore } from "../store/useUserStore";
import { useAuthStore } from "../store/useAuthStore";

const ErrorPermission = () => <Navigate to={routes.forbidden} />;

// Verifica si hay un token
const ProtectedRoute = ({ element, allowedRoles = [] }) => {
  const token = useAuthStore((s) => s.session?.authenticationToken) || sessionStorage.getItem("authenticationToken");
  const isSignedIn = !!token;

  const user = useUserStore((state) => state.userInfo);

  if (!isSignedIn) {
    return <Navigate to={routes.root} />;
  }

  if (allowedRoles.length > 0 && !user?.roles?.some((role) => allowedRoles.includes(role))) {
    return <ErrorPermission />;
  }

  return element;
};

// Si ya está autenticado manda a home
const RedirectToHomeIfAuthenticated = ({ element }) => {
  const token = useAuthStore((s) => s.session?.authenticationToken) || sessionStorage.getItem("authenticationToken");
  const isSignedIn = !!token;

  return isSignedIn ? <Navigate to={routes.home} /> : element;
};

const AppRouter = () => {
  return (
    <Routes>
      <Route path={routes.root} element={<RedirectToHomeIfAuthenticated element={<Root />} />} />
      <Route path={routes.usuariosLogin} element={<UsersLogin />} />
      <Route path={routes.aplicacion} element={<ProtectedRoute element={<Aplicacion />} />} />
      <Route path={routes.aplicaciones} element={<ProtectedRoute element={<ApplicationsDetailsPage />} allowedRoles={["admin"]} />} />
      <Route path={routes.usuarios} element={<ProtectedRoute element={<UsersPage />} allowedRoles={["manager", "admin"]} />} />
      <Route path={routes.home} element={<ProtectedRoute element={<HomePage />} />} />
      <Route path={routes.cuestionariosPorFase} element={<PhaseQuestionnairesPage />} />
      <Route path={routes.documentosAsociados} element={<ProtectedRoute element={<DocViewerPage />} />} />
      <Route path={routes.usuarioDetalle} element={<ProtectedRoute element={<UserDetailsPage />} allowedRoles={["manager", "admin"]} />} />
      <Route path={routes.usuarioCrear} element={<ProtectedRoute element={<CreateUserPage />} allowedRoles={["manager", "admin"]} />} />
      <Route path={routes.asignacionCrear} element={<ProtectedRoute element={<CreateAssignmentPage />} allowedRoles={["manager", "admin"]} />} />
      <Route path={routes.cuestionarios} element={<ProtectedRoute element={<QuestionnairesPage />} allowedRoles={["admin", "manager"]} />} />
      <Route path={routes.cuestionarioCrear} element={<ProtectedRoute element={<QuestionnaireCreatePage />} allowedRoles={["admin", "manager"]} />} />
      <Route path={routes.cuestionarioPreview} element={<ProtectedRoute element={<QuestionnairePreview />} allowedRoles={["admin", "manager"]} />} />
      <Route path={routes.aspectos} element={<ProtectedRoute element={<AspectsPage />} allowedRoles={["admin", "manager"]} />} />
      <Route path={routes.preguntas} element={<ProtectedRoute element={<QuestionsPage />} allowedRoles={["admin", "manager"]} />} />
      <Route path={routes.instrumentos} element={<ProtectedRoute element={<InstrumentsPage />} allowedRoles={["admin", "manager"]} />} />
      <Route path={routes.reporteAsignaciones} element={<ProtectedRoute element={<ApplicationAssignmentsPage />} allowedRoles={["admin"]} />} />
      <Route path={routes.reportes} element={<ProtectedRoute element={<ReportsPage />} allowedRoles={["admin"]} />} />

      <Route
        path={routes.tiposOpcionesRespuesta}
        element={<ProtectedRoute element={<AnswerTypesOptionsPage />} allowedRoles={["admin", "manager"]} />}
      />

      <Route path={routes.forbidden} element={<ForbiddenPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRouter;
